// Categories of things the user can select in the 2D editor.
//
// - Field    : a real domain entity carrying product content (image,
//              textbox). Layered / lockable / persisted / exported.
// - Grid     : the alignment helper overlay. Rendered as chrome, but
//              a domain-level tool the user (any user) can toggle;
//              excluded from reordering, locking and export.
// - None     : no active selection.
//
// The cut shape is deliberately absent: it is product configuration
// rather than content, cannot be transformed, and is removed from the
// topbar — so it is rendered non-selectable and never reaches here.
//
// Engine adapters translate their internal state (fabric group IDs,
// active object references) into this enum so the presentation layer
// branches on a typed discriminant instead of comparing IDs against
// infrastructure sentinels.

enum ESelectionKind {
    Field = 'field',
    Grid = 'grid',
    None = 'none',
}

export { ESelectionKind };
